<table mat-table [dataSource]="response.dataSourceTable" class="mat-elevation-z8 fixTable">

  <ng-container *ngFor="let item of response.displayedReference; let i = index">
    <ng-container [matColumnDef]="item">

      <th mat-header-cell *matHeaderCellDef> {{response.nameHeader[i]}} </th>

      <ng-container *ngIf="item === 'nrCnpjCpf'">
        <td  mat-cell *matCellDef="let element"> {{ element[item] | CpfCnpj }} </td>
      </ng-container>


      <ng-container *ngIf="item !== 'actions'">
        <td  mat-cell *matCellDef="let element"> {{response.typeData[i] === 'decimal' ? (element[item] | currency : 'R$') : element[item]}} </td>
      </ng-container>
      <ng-container *ngIf="item === 'actions'">
        <td mat-cell *matCellDef="let element">
          <ng-container *ngFor="let item of response.buttons;">
            <button
              *ngIf="!item.hide"
              mat-button
              [disabled]="item.disabled"
              [matTooltip]="item.tooltip"
              (click)="(item.tooltip === 'Remover' ? remover(element) : clear())"
            >
              <img src="../../../assets/icons/{{item.icon}}.svg">
            </button>
          </ng-container>
        </td>
      </ng-container>

    </ng-container>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="response.displayedReference"></tr>
  <tr mat-row *matRowDef="let row; columns: response.displayedReference;"></tr>
</table>
